import { HeroLines } from "@/components/site/Motion";
import { LinkButton } from "@/components/site/LinkButton";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { CoachingScope } from "@/components/site/CoachingScope";
import { HeroMark } from "./HeroMark";

export const HomeHero = () => (
  <section className="ink-wash grain relative overflow-hidden pt-32 sm:pt-36" data-testid="home-hero">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 sm:px-8 md:pb-28 lg:grid-cols-[1.4fr_0.8fr] lg:gap-8 lg:px-12">
      <div className="relative z-10 order-2 lg:order-1">
        <p className="eyebrow text-center sm:text-left">Panchmaya · From darkness to light</p>
        <HeroLines
          testId="home-hero-title"
          lines={["Perceive.", <em key="r" className="text-[#7a5615]">Release.</em>, "Reconnect."]}
          className="font-display mt-6 text-center text-[3.4rem] font-normal leading-[0.98] tracking-tight text-[#221e1b] sm:text-left sm:text-7xl lg:text-[6.5rem]"
        />
        <p className="mt-8 max-w-xl text-base leading-relaxed text-[#5d544c] md:text-lg">
          Panchmaya is a guided journey of self-exploration inspired by the traditional philosophy of
          the five koshas. Through lifestyle coaching, we explore these five layers of experience,
          from the body we live in to the quiet sense of self underneath.
          Become aware of how you meet the world, make space to let go of what you carry, and come
          back to yourself.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 sm:justify-start">
          <WhatsAppButton testId="hero-whatsapp-btn">Inquire About 1:1 Coaching via WhatsApp</WhatsAppButton>
          <LinkButton to="/journey" variant="outline" testId="hero-explore-journey-btn">Explore the 21-Day Journey</LinkButton>
        </div>
        <CoachingScope />
      </div>
      <div className="order-1 mx-auto w-[68%] max-w-[300px] sm:max-w-[380px] lg:order-2 lg:w-full lg:max-w-none">
        <HeroMark />
      </div>
    </div>
  </section>
);
